import React, { useContext, useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import "./PaginationProducts.css";
import { GetUserContext } from "../Context/GetUserContext";
import newFraga from "../controller/api/New_Fraga";

const PaginationProducts = () => {
    const {
        nomePeca, setNamePeca, take, page, setPage,
        currentPage, totalPages, selectedFabricante,
        selectedBrands, setSelectedBrands, selectedNames,
        setSelectedNames, selectedModels, setSelectedModels,
        selectedAllYears, setSelectedAllYears, selectedEnginer,
        setSelectedEnginer, selectedEnginerConfig, setSelectedEnginerConfig,
        products, setOrdenarPreco, setProducts, setLoad, setFetchTimestamp,
        originalProducts, setOriginalProducts, filterEstoque, setFilterEstoque,
        setCurrentPage, setTotalPages
    } = useContext(GetUserContext);

    const handlepaginationAdd = () => {
        setPage(prev => prev + 1);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'  
        });
    };

    const handlepaginationRemove = () => {
        setPage(prev => (prev > 1 ? prev - 1 : 1));
    };



    return (
        <div className="container-pagination">

            {
                page > 1 ?
                    (<>
                        <button className="btn btn-warning" onClick={handlepaginationRemove}>Voltar</button>
                        <div style={{ visibility: "hidden" }}>*****</div>
                    </>)
                    :
                    (<></>)
            }

            <button className="btn btn-warning" onClick={handlepaginationAdd}>Proximo</button>

        </div>
    );
};

export default PaginationProducts;
